import i18next, { type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import nbResources from './nb.json';

/**
 * i18n singleton (Plan 01-10).
 *
 * v1 is Norwegian Bokmål only. `fallbackLng: false` + `supportedLngs: ['nb']`
 * guarantees the app never silently serves English — if a key is missing,
 * react-i18next returns the key itself (returnNull / returnEmptyString both
 * off) so the DOM surfaces the gap loudly.
 *
 * Future English is a content-only change: add `resources.en` + flip
 * `supportedLngs` + route off the device locale. No code rewrite required
 * (D-02 vision).
 *
 * Import this module once from `main.tsx` BEFORE React mounts. Downstream
 * components consume translations via `useTranslation()` from react-i18next;
 * the singleton is already initialised by the time any component renders.
 */

export const i18n: I18nInstance = i18next.createInstance();

i18n.use(initReactI18next).init({
  lng: 'nb',
  fallbackLng: false,
  supportedLngs: ['nb'],
  resources: { nb: { translation: nbResources } },
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
  debug: import.meta.env.DEV,
});

export default i18n;
